import { useContext } from 'react'
import { useQuery } from '@tanstack/react-query'
import { AuthContext } from '../context/AuthContext'
import { DEFAULT_PRODUCT, subscriptionService } from '../services/subscriptionService'

export function useEntitlements(product = DEFAULT_PRODUCT) {
  const auth = useContext(AuthContext)
  const tenantId = auth?.user?.tenant_id ?? auth?.user?.tenantId
  const enabled = Boolean(auth?.isAuthenticated && tenantId)
  const query = useQuery({
    queryKey: ['entitlements', tenantId, product],
    queryFn: () => subscriptionService.entitlements(product),
    enabled,
    staleTime: 30_000,
    retry: false,
    refetchInterval: enabled ? 30_000 : false,
  })
  const available = enabled && !query.isError && Boolean(query.data)
    && Date.now() < Date.parse(query.data?.subscription.periodEnd ?? '')
  return {
    ...query,
    hasFeature: (key: string) => available && query.data?.features[key] === true,
    getLimit: (key: string) => available ? query.data?.limits[key] : undefined,
  }
}
